import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { resetFileDownload } from '../../../redux/modules';
import { Outlet } from 'react-router-dom';

import './MainContent.css';

const MainContent = () => {
    const dispatch = useDispatch();
    const { file } = useSelector(state => state.downloads);

    // we handle all file download here
    useEffect(() => {
        if (file) {
            dispatch(resetFileDownload());
            const url = window.URL.createObjectURL(new Blob([file]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                'download.pdf'
            );
            document.body.appendChild(link);
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }
    }, [file]);

    return (
        <div className="MainContent">
            <Outlet />
        </div>
    );
}

export default MainContent;
